import React from "react";
import { format, parseISO } from "date-fns";
import { Signature } from "@/types";

interface SignatureDisplayProps {
  signature: Signature;
  label?: string;
  showTimestamp?: boolean;
  className?: string;
  imageClassName?: string;
}

const SignatureDisplay: React.FC<SignatureDisplayProps> = ({
  signature,
  label,
  showTimestamp = true,
  className = "",
  imageClassName = "w-64",
}) => {
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {showTimestamp && (
        <p className="text-sm">
          Signed by {signature.name} on{" "}
          {format(parseISO(signature.created_at), "MM/dd/yyyy hh:mm a")}
        </p>
      )}
      <div>
        <img
          src={
            signature.blob.startsWith("data:")
              ? signature.blob
              : `data:image/png;base64,${signature.blob}`
          }
          alt={`${signature.signed_by} Signature`}
          className={imageClassName}
        />
      </div>
      {label && (
        <div className="flex flex-col">
          <p className="text-sm">{label}</p>
        </div>
      )}
    </div>
  );
};

export default SignatureDisplay;
